import { useEffect, useState } from 'react';

type MediaQueryOptions = {
  query: string;
  defaultMatches?: boolean;
};

export function useMediaQuery({
  query,
  defaultMatches = false,
}: MediaQueryOptions) {
  const [matches, setMatches] = useState(defaultMatches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const updateMatches = () => setMatches(mediaQuery.matches);

    updateMatches();
    mediaQuery.addEventListener('change', updateMatches);

    return () => mediaQuery.removeEventListener('change', updateMatches);
  }, [query]);

  return matches;
}
